import React from "react";
import { apiEndpoints } from "../../config";

// Modules
import PostAdd from "../../partials/posts/postAdd";

export default function AddQuiz(props) {
  return(
    <PostAdd 
      targetVid={"quiz_categories"}
      addPostEndpoint={apiEndpoints.quiz}
      editRoute={"/quizzes/edit"}
      entityType={"quiz"}
      pageTitle={"Create a quiz post"}
      returnRoute={"/quizzes-creator"}
    />
  )
}
